import { ChangeEvent } from 'react'

import { useRouter } from 'next/router'

import { ThemesPropertyFragment } from '@/generated/contentful'

type Props = {
	collection?: ThemesPropertyFragment['items'][0]
}

export const ThemesCollectionButton = ({ collection }: Props) => {
	const { query, push } = useRouter()
	const queryCollection = typeof query.collection === 'string' ? query.collection : 'all'

	const handleOnChangeCollection = (e: ChangeEvent<HTMLInputElement>) => {
		const collection = e.target.value

		push({ query: { ...query, collection: collection === 'all' ? [] : collection } }, undefined, {
			shallow: true
		})
	}

	return (
		<label key={collection?.slug} className="flex items-center my-2 cursor-pointer">
			<input
				type="radio"
				name="collection"
				checked={
					decodeURIComponent(queryCollection) === collection?.name ||
					(!query.collection && collection?.name === 'All')
				}
				value={collection?.name!}
				className="radioInput"
				onChange={(e) => handleOnChangeCollection(e)}
			/>
			{collection?.name}
		</label>
	)
}
